import {injectable} from 'inversify'
import type {ILoggerService} from '@/src/ports/services/logger'
import {logger} from '@/src/shared/utils/logger'
import * as Sentry from '@sentry/nextjs'
// import {settings} from '@/src/config/settings'

/**
 * Console Logger Service
 *
 * Development-friendly logger that outputs to console.
 * Use in development environment for debugging.
 */
@injectable()
export class LoggerService implements ILoggerService {
  debug(message: string, context?: Record<string, unknown>): void {
    // if (!['development', 'local', 'test'].includes(settings.NEXT_PUBLIC_APP_ENV)) {
    //   return
    // }

    const pinoLogFn = logger.debug
    const sentryLogFn = Sentry.logger.debug

    const $this = typeof window === 'undefined' ? logger: null

    const logArgs = (
      typeof window === 'undefined' ? [context, message] : [message, context]
    ).filter(x => !!x)

    const logFn: any = typeof window === 'undefined' ? pinoLogFn : sentryLogFn

    if (typeof window !== 'undefined') {
      // @ts-ignore
      pinoLogFn.call(logger, ...logArgs)
    }

    logFn.call($this, ...logArgs)
  }

  info(message: string, context?: Record<string, unknown>): void {


    const pinoLogFn = logger.info
    const sentryLogFn = Sentry.logger.info

    const $this = typeof window === 'undefined' ? logger: null

    const logArgs = (
      typeof window === 'undefined' ? [context, message] : [message, context]
    ).filter(x => !!x)

    const logFn: any = typeof window === 'undefined' ? pinoLogFn : sentryLogFn

    if (typeof window !== 'undefined') {
      // @ts-ignore
      pinoLogFn.call(logger, ...logArgs)
    }

    logFn.call($this, ...logArgs)
  }

  warn(message: string, context?: Record<string, unknown>): void {


    const pinoLogFn = logger.warn
    const sentryLogFn = Sentry.logger.warn

    const $this = typeof window === 'undefined' ? logger: null

    const logArgs = (
      typeof window === 'undefined' ? [context, message] : [message, context]
    ).filter(x => !!x)

    const logFn: any = typeof window === 'undefined' ? pinoLogFn : sentryLogFn

    if (typeof window !== 'undefined') {
      // @ts-ignore
      pinoLogFn.call(logger, ...logArgs)
    }

    logFn.call($this, ...logArgs)
  }

  error(message: string, error: unknown, context?: Record<string, unknown>): void {


    const pinoLogFn = logger.error
    const sentryLogFn = Sentry.logger.error

    const $this = typeof window === 'undefined' ? logger: null

    const logArgs = (
      typeof window === 'undefined'
        ? [{...context, error: error}, message]
        : [message, {...context, error: error}]
    ).filter(x => !!x)

    const logFn: any = typeof window === 'undefined' ? pinoLogFn : sentryLogFn

    if (typeof window !== 'undefined') {
      // @ts-ignore
      pinoLogFn.call(logger, ...logArgs)
    }

    logFn.call($this, ...logArgs)
  }
}
